"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriceList = function (_Component) {
  (0, _inherits3.default)(PriceList, _Component);

  function PriceList() {
    (0, _classCallCheck3.default)(this, PriceList);
    return (0, _possibleConstructorReturn3.default)(this, (PriceList.__proto__ || (0, _getPrototypeOf2.default)(PriceList)).apply(this, arguments));
  }

  (0, _createClass3.default)(PriceList, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Hinnasto" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              "Hinnasto"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Ilmoituksien ja\u0308tta\u0308minen on Maapo\u0308rssin palvelussa ilmaista. Ilmoitukset saavat olla arvioivia eiva\u0308tka\u0308 ne velvoita mihinka\u0308a\u0308n. Ilmoitathan vain puhtaita maa-aineksia silla\u0308 saastuneet eiva\u0308t sovellu uusioka\u0308ytto\u0308o\u0308n ilman ka\u0308sittelya\u0308. Ilmoituksen pa\u0308a\u0308set ja\u0308tta\u0308ma\u0308a\u0308n kohdasta",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/jata-ilmoitus" },
                "\u201DIlmoita ilmaiseksi\u201D"
              ),
              "."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Ammattilaisprofiili"
            ),
            _react2.default.createElement(
              "ul",
              null,
              _react2.default.createElement(
                "li",
                null,
                "Ilmoitusten tarkkojen tietojen lukeminen"
              ),
              _react2.default.createElement(
                "li",
                null,
                "Ilmoitukset n\xE4kyv\xE4t kartalla oikeissa paikoissa"
              ),
              _react2.default.createElement(
                "li",
                null,
                "Omien ilmoitusten muokkaaminen ja poistaminen"
              ),
              _react2.default.createElement(
                "li",
                null,
                "Viikon vinkit sa\u0308hko\u0308postiisi"
              ),
              _react2.default.createElement(
                "li",
                null,
                "Kuljetustarjouspyynto\u0308jen vastaanottaminen"
              )
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "Hinnoittelu:"
              ),
              _react2.default.createElement("br", null),
              "Profiilin hinta on 225\u20AC (282,40\u20AC sis. alv. 25.5%) / 6 kk",
              _react2.default.createElement("br", null),
              "Yli 6 kk sopimuksissa ja suuremmissa profiilima\u0308a\u0308rissa\u0308 ota yhteys myyntiin.",
              _react2.default.createElement("br", null),
              "Rekistero\u0308i Ammattilaisprofiili",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/rekisteroidy" },
                "ta\u0308ma\u0308n linkin"
              ),
              " kautta."
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "Myynti:"
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "a",
                { href: "tel:+358444279803" },
                "044 427 9803"
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "a",
                { href: "mailto:asiakaspalvelu@maaporssi.fi" },
                "asiakaspalvelu@maaporssi.fi"
              )
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Vastaanottolipukkeet"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Vastaanottolipukkeita voivat ostaa kaikki Maapo\u0308rssin sivuston ka\u0308vija\u0308t. Profiilia ei ostamiseen tarvita. Vastaanottolipukkeiden hinnat vaihtelevat lipukkeessa mainitun vastaanottopaikan, vastaanotetun maa- aineksen ja maa-aineksen ma\u0308a\u0308ra\u0308n mukaan. Vastaanottolipukkeen hinta mainitaan osiossa",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/lipukekauppa" },
                "\u201DVastaanottolipukkeet\u201D"
              ),
              " kunkin lipukkeen yhteydessa\u0308 erikseen."
            )
          )
        )
      );
    }
  }]);
  return PriceList;
}(_react.Component);

exports.default = PriceList;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PriceList/PriceList.js
 ** module id = 1228
 ** module chunks = 0
 **/